import { useEffect } from 'react';
import { FormLayout } from '@/pages/auth/components/FormLayout';
import { Button } from '@/components/ui/button';
import { FormattedText } from '@/components/uiKit/FormattedText';
import { useNavigate } from 'react-router-dom';
import { locations } from '@/locations';
import { analytics } from '@/analytics';
import { Icon } from '@/components/shared/display/Icon';
import { EmailConfirmedIcon } from '@/assets/Icons';
import { colors } from '@/constants/colors';

export const PasswordChangedPage = () => {
  const navigate = useNavigate();
  const goBackToLogin = () => navigate(locations.public.login);

  useEffect(() => {
    analytics.page({
      name: 'Password changed',
      title: 'DataMind Dashboard 2.0 - Password changed',
    });
  }, []);

  return (
    <FormLayout
      title="auth.resetPassword.changed.heading"
      subtitle="auth.resetPassword.changed.description"
      icon={<Icon icon={EmailConfirmedIcon} className={`w-16 h-16 text-[${colors.health.healthy}] mb-6`} />}
    >
      <div className="flex items-center justify-center xl:justify-end">
        <Button variant="default" size="lg" className="rounded-full" onClick={goBackToLogin}>
          <FormattedText label="auth.resetPassword.changed.submit" />
        </Button>
      </div>
    </FormLayout>
  );
};
